import { StyleSheet } from 'react-native';
import { Colors } from 'react-native-paper';
import { appColors } from '../../../assets/styles/global';
import { pixelDimensions } from '../../../config/utils';

const styles = StyleSheet.create({
  buttonBack: {
    alignSelf: 'flex-end',
    backgroundColor: appColors.primary,
    paddingVertical: pixelDimensions(2),
    paddingHorizontal: pixelDimensions(6),
    marginHorizontal: pixelDimensions(4),
    marginVertical: pixelDimensions(2),
  },
  container: {
    marginTop: pixelDimensions(2),
    flex: 1,
  },
  textBack: {
    color: Colors.white,
    fontSize: pixelDimensions(4.5),
  },
  textAnswers: {
    fontSize: pixelDimensions(4.5),
  },
  textCenter: {
    textAlign: 'center',
  },
  textTitle: {
    fontSize: pixelDimensions(6),
  },
  textSubTitle: {
    fontSize: pixelDimensions(5),
  },
  textQA: {
    fontSize: pixelDimensions(4),
  },
  questions: {
    alignItems: 'center',
    marginBottom: pixelDimensions(2),
  },
  viewCircle: {
    height: pixelDimensions(15),
    width: pixelDimensions(15),
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: appColors.primary,
    borderRadius: pixelDimensions(50),
    padding: pixelDimensions(3),
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: pixelDimensions(3),
  },
  textQuestion: {
    fontSize: pixelDimensions(4),
    alignSelf: 'center',
  },
  viewEvaluation: {
    marginHorizontal: pixelDimensions(2),
  },
  viewGraph: {
    alignItems: 'center',
  },
  viewLinesContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  viewQuestion: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginHorizontal: pixelDimensions(5),
    marginVertical: pixelDimensions(2),
  },
  viewDreamQuality: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: pixelDimensions(2),
  },
  viewResponses: {
    flexDirection: 'row',
    marginTop: pixelDimensions(2),
  },
});

export default styles;
